// extracted by mini-css-extract-plugin
module.exports = {"header":"TariffCalculatorProduct_header_2OUnI"};